<template>
<span>
  <fa icon="pencil-alt" @click.prevent="open = !open" :id="id" :style="{ color: color }" />
  <b-popover :show.sync="open" :target="id">
    <b-input-group>
      <b-input v-model="localValue"/>
      <b-input-group-append>
        <b-button variant="outline-success" @click.prevent="setValue">
          <fa icon="check"/>
        </b-button>
        <b-button variant="outline-danger" @click.prevent="open=false">
          <fa icon="times"/>
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </b-popover>
</span>
</template>

<script>
  export default {
    name: 'o-inline-edit',
    props: {
      value: {
        default: null
      },
      color: {
        type: String,
        default: 'black'
      }
    },

    data: () => ({
      localValue: '',
      open: false,
      id: ''
    }),

    mounted() {
      this.id = 'o-inline-edit-' + Math.floor(Math.random() * 9999999)
      this.localValue = this.value
    },

    watch: {
      value(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.localValue = newVal
        }
      }
    },

    methods: {
      setValue() {
        this.$emit('input', this.localValue)
        this.open = false
      }
    }
  }

</script>
